// eslint-disable-next-line no-unused-vars
var Homepage = Barba.BaseView.extend({
    namespace: 'homepage',
    decorationClasses: [ "moon-f", "moon-t", "moon-r", "moon-b", "moon-l" ],
    updateThumbnails: function() {
        const $thumbs = $('.thumbnail');
        for (let i = 0; i < $thumbs.length; i+=2) {
            const indx =  Math.round(Math.random());
            const $wide = $thumbs.eq(i + indx);
            const $square = $thumbs.eq(i + (1 - indx));
            $wide.addClass('thumbnail--wide');
            $square.addClass('thumbnail--square');

            if (Math.round(Math.random())) $square.addClass('thumbnail--right');
            $square.addClass('thumbnail--'+this.decorationClasses[Math.floor(Math.random()*this.decorationClasses.length)]);
            
            // update images
            const $wideimg = $('.thumbnail__image',$wide);
            const wideurl = $wideimg.data('wideurl');
            if (wideurl) $wideimg.attr('style','background-image:url('+wideurl+')');

            const $squareimg = $('.thumbnail__image',$square);
            const squareurl = $squareimg.data('squareurl');
            if (squareurl) $squareimg.attr('style','background-image:url('+squareurl+')');
        }
        $('.projects--loading').removeClass('projects--loading');
    },
    scrollAnimLogo: function() {
        var initLogoTop = $('.homeheader__title').eq(0).offset().top - 200;
        $(window).off('scroll.animLogo');
        $(window).on('scroll.animLogo',function() {
            var logoTop = $('.homeheader__title').get(0).getBoundingClientRect().top;
            var opacity = Math.min(1,Math.max(0,logoTop/initLogoTop));
            $('.homeheader__title span').css('opacity',opacity);
            $('.header').toggleClass('header--visible',opacity <= 0);
        }).trigger('scroll');
    },
    onEnter: function() {
        this.updateThumbnails();
        $('.header').removeClass('header--visible');
        // $('.header__background').css('opacity',0);
    },
    onEnterCompleted: function() {
        this.scrollAnimLogo();
    },
    onLeave: function() {
        $('.header').addClass('header--visible');
        $(window).off('scroll.animLogo');
    },
    onLeaveCompleted: function() {
    }
  });
